import { Button, Divider, Grid, Typography } from "@mui/material";
import { t } from "i18next";

import type { EndPointSectionFieldsFragment } from "@/libs/generated/operations";
import { preloadCompressedVehicleImages } from "@/utils/compressed-vehicle-image";
import { VehiclePhotos } from ".";
import { ImageComparisonView, ZoomModal } from "./components";
import { usePreviewPhotoModal } from "./hooks";
import { toPhotoVehicle } from "./types";
import { getImageSources } from "./utils";

type PreviewPhotoModalProps = {
  delivery: EndPointSectionFieldsFragment;
  index: number;
};

function PreviewPhotoModal({ delivery, index }: PreviewPhotoModalProps) {
  const {
    open,
    selectedKey,
    zoomImage,
    handleImagePreviewClick,
    handleImageZoom,
    handleCloseZoom,
    handleOpenModal,
    handleCloseModal,
  } = usePreviewPhotoModal();

  const vehicle = delivery.vehicles[index];

  if (!vehicle) {
    return null;
  }
  const photoVehicle = toPhotoVehicle(vehicle);

  const handleOpen = () => {
    void preloadCompressedVehicleImages([
      ...getImageSources(photoVehicle.imagesBefore),
      ...getImageSources(photoVehicle.imagesAfter),
    ]);
    handleOpenModal();
  };

  return (
    <>
      <Button fullWidth variant="contained" color="primary" onClick={handleOpen}>
        {t("common.buttons.view-photos")}
      </Button>

      <VehiclePhotos.Root open={open} onClose={handleCloseModal}>
        <Grid container spacing={3} sx={{ width: "100%" }} p={1}>
          <Grid size={{ xs: 3 }}>
            <VehiclePhotos.Section
              type="before"
              vehicle={photoVehicle}
              images={photoVehicle.imagesBefore}
              isPreview
              onImageClick={handleImagePreviewClick}
            />
          </Grid>

          <Grid size={{ xs: 1 }} sx={{ display: "flex", justifyContent: "center" }}>
            <Divider orientation="vertical" />
          </Grid>

          <Grid container size={{ xs: 8 }} spacing={2}>
            {selectedKey ? (
              <ImageComparisonView
                vehicle={photoVehicle}
                selectedKey={selectedKey}
                onImageZoom={handleImageZoom}
              />
            ) : (
              <Grid size={{ xs: 12 }}>
                <Typography variant="h6" align="center" mt={19}>
                  {t("delivery.titles.view")}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
      </VehiclePhotos.Root>

      <ZoomModal open={Boolean(zoomImage)} imageSrc={zoomImage} onClose={handleCloseZoom} />
    </>
  );
}

export default PreviewPhotoModal;
